import * as React from "react"
import { graphql } from "@apollo/react-hoc"

export default (query, config) => {
  return component => {
    return props => {
      return React.createElement(
        graphql(query(props), config)(component),
        props,
      )
    }
  }
}
